import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import updateAccessRightService from '../services/updateAccessRightService';
import AccessRightFormModal from './AccessRightFormModal';
import accessRightService from '../services/accessRightService';

class EditAccessRightModal extends PureComponent {
  componentWillUpdate(nextProps) {
    const { accessRightId } = nextProps;
    if (accessRightId && accessRightId !== this.props.accessRightId) {
      this.props.dispatchAccessRightGet(accessRightId);
    }
  }
  componentWillMount() {
    const { accessRightId } = this.props;
    if (accessRightId) {
      this.props.dispatchAccessRightGet(accessRightId);
    }
  }
  handleSubmit = body => {
    this.props.dispatchUpdateAccessRightPut(this.props.accessRightId, body, this.props.returnRoute);
  };
  render() {
    const { updateAccessRightFetch, accessRightFetch, accessRightId, licensePlate, t } = this.props;
    if (!accessRightId) {
      return null;
    }
    return (
      <AccessRightFormModal
        header={t('editAccessRightForVehicle', {
          licensePlate: licensePlate || get(accessRightFetch.value, 'licensePlate', '...'),
        })}
        onSubmit={this.handleSubmit}
        submitProcessing={!!updateAccessRightFetch.pending}
        data={!accessRightFetch.fulfilled ? {} : { ...accessRightFetch.value }}
        dataLoading={!!accessRightFetch.pending}
        licensePlate={licensePlate}
        editMode
      />
    );
  }
}

EditAccessRightModal.propTypes = {
  t: PropTypes.func.isRequired,
  dispatchUpdateAccessRightPut: PropTypes.func.isRequired,
  dispatchAccessRightGet: PropTypes.func.isRequired,
  updateAccessRightFetch: PropTypes.object.isRequired,
  accessRightFetch: PropTypes.object.isRequired,
  accessRightId: PropTypes.string,
  returnRoute: PropTypes.string,
  licensePlate: PropTypes.string,
};

EditAccessRightModal.defaultProps = {
  accessRightId: undefined,
  licensePlate: undefined,
  returnRoute: '/all-accessrights',
};

export default compose(
  withTranslation(),
  updateAccessRightService,
  accessRightService
)(EditAccessRightModal);
